<script setup>
const { legend = null } = defineProps({
    legend: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <div class="mb-4 flex flex-col">
        <div
            class="flex flex-wrap items-start gap-4 rounded-sm border border-gray-200 p-4 [&>*]:mb-0!"
        >
            <slot />
        </div>

        <em v-if="legend" class="mt-1 text-xs text-gray-400">
            {{ legend }}
        </em>
    </div>
</template>
